import FinalizeJobsNoLongerReadyChoiceEnum from '../Enums/FinalizeJobsNoLongerReadyChoiceEnum';
import FinalizeJobsNoLongerReadyChoiceOptionsArray from '../Enums/FinalizeJobsNoLongerReadyChoiceOptionsArray';
import RoleService from '../Services/roleService';
import ValidityHelper from './ValidityHelper';

// Whether the user may keep the shops that no longer pass the Ready for Invoicing rules on the invoices they finalize:
// only with the InvoiceReadinessOverride role. Everyone else's are taken off.
export function canKeepJobsNoLongerReady() {
  return RoleService.CheckUserPermission('inputfield', 'tpclientinvoices_readinessoverride');
}

// The finalize windows' choice of what to do with the shops that no longer pass the Ready for Invoicing rules: Remove,
// which the windows start on, and Keep only for a user who may keep them.
export function getJobsNoLongerReadyChoiceOptions() {
  if (canKeepJobsNoLongerReady()) {
    return FinalizeJobsNoLongerReadyChoiceOptionsArray;
  }
  return FinalizeJobsNoLongerReadyChoiceOptionsArray.filter(
    (option) => option.value !== FinalizeJobsNoLongerReadyChoiceEnum.Keep
  );
}

// Whether the invoice being finalized holds shops that no longer pass the Ready for Invoicing rules, as the window
// read them when it opened (JobsNoLongerReady).
export function hasJobsNoLongerReady(item) {
  return (item.JobsNoLongerReady ?? []).length > 0;
}

export function checkJobsNoLongerReadyChoice(value) {
  return value ? '' : 'Choose whether to remove these shops or keep them.';
}

// Keeping the shops needs a comment saying why; otherwise the comment is optional.
export function checkFinalizeComment(value, item) {
  if (item?.JobsNoLongerReadyChoice === FinalizeJobsNoLongerReadyChoiceEnum.Keep) {
    return ValidityHelper.forRequiredTextField(value);
  }
  return '';
}

// The finalize request: whether to keep those shops, from the choice, and without what is there only for the window.
export function getFinalizeRequest(item) {
  const { JobsNoLongerReady, JobsNoLongerReadyChoice, ...request } = item;
  return {
    ...request,
    KeepJobsNoLongerReady: JobsNoLongerReadyChoice === FinalizeJobsNoLongerReadyChoiceEnum.Keep,
  };
}
